import { render, staticRenderFns } from "./EtagBanner.vue?vue&type=template&id=b6fa988a&scoped=true"
import script from "./EtagBanner.vue?vue&type=script&lang=js"
export * from "./EtagBanner.vue?vue&type=script&lang=js"
import style0 from "./EtagBanner.vue?vue&type=style&index=0&id=b6fa988a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6fa988a",
  null
  
)

export default component.exports